module.exports = __webpack_public_path__ + "img/rili.365fdc10.png";